import type { UIInventoryItem, UIPartyCharacter } from '@sorrem-client/types';
import { useItemTransferContext } from '@sorrem-client/ui/components';
import { resolveCharacterHomeItemCard, useCharacterHomeCharacter } from '@sorrem-client/ui/features/CharacterHome/components/CharacterHomeItemTransfer';
import { resolveCraftingPreview, type CraftingPreview } from './crafting-preview';

export interface CraftingItem {
    readonly character: UIPartyCharacter | null;
    /** The selected item, when it is equipment (the only thing crafting works on); carried, stored or equipped. */
    readonly item: UIInventoryItem | null;
    readonly preview: CraftingPreview | null;
}

/** What the Crafting tab's panels work on: the shared item selection, and what crafting would do to it. */
export function useCraftingItem(): CraftingItem {
    const character = useCharacterHomeCharacter();
    const { selectedItemId } = useItemTransferContext();
    const item = character === null || selectedItemId === null ? undefined : resolveCharacterHomeItemCard(character, selectedItemId)?.item;
    if (item === undefined || item.equipmentType === undefined) {
        return { character, item: null, preview: null };
    }
    return { character, item, preview: resolveCraftingPreview(item) };
}
